// extracted by mini-css-extract-plugin
export var divider = "_d7-7";
export var itemsToggle = "_d7-8";
export var mergeModal = "_d7-1";
export var optionCard = "_d7-4";
export var radioGroup = "_d7-6";
export var radioOption = "_d7-0";
export var selected = "_d7-5";
export var shipmentOptions = "_d7-2";
export var tableOptions = "_d7-3";